export default "__VITE_ASSET__CGPk0MFA__"